import { render, staticRenderFns } from "./CategoriesChart.vue?vue&type=template&id=7a6bb5b1&"
import script from "./CategoriesChart.vue?vue&type=script&lang=js&"
export * from "./CategoriesChart.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports